export default __webpack_public_path__ + "static/clandestinna-balthazaurus-scroll-3c50b029c8374ac765b0667d599bb5be.mp4";